import { Typography } from 'antd';
import { maxWidth, maxWidth1300, retina, secondaryFont, secondaryHeadingColor, wMBold } from 'constants/utilsStyles';
import React from 'react';
import styled from 'styled-components';
import SkeletonCustom from '../Skeleton/SkeletonCustom';

const { Paragraph } = Typography;

const Wrapper = styled(Paragraph)`
  font-family: ${secondaryFont};
  font-weight: ${wMBold};
  font-size: 24px;
  line-height: 32px;
  color: ${secondaryHeadingColor};
  margin-bottom: 0 !important;
  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 22px;
    line-height: 28px;
  }
  @media all and (max-width: ${maxWidth1300}) {
    font-size: 20px;
    line-height: 24px;
  }
  :hover {
    cursor: context-menu;
  }
  .ml-1 {
    margin-left: 5px;
    margin-right: 5px;
  }
`;

const SecondaryHeading = function SecondaryHeading({ title, count, loadingFlag }: { title: string, count?: string, loadingFlag?: boolean }) {
  return (
    <>
      <Wrapper className='secondary-heading text-truncate' ellipsis={{ rows: 1, tooltip: title }}>
        {title}
      </Wrapper>
      <Wrapper className='secondary-heading mr-1 ml-c-1'>
        {count}
      </Wrapper>
    </>
  );
};
export default SecondaryHeading;